/* eslint-disable */

/**
 * This is users script.js file
 */
import { email, maxLength, minLength, required, requiredIf } from 'vuelidate/lib/validators';
import ActionsDetail from '@/components/actions-detail/index.vue';
import DispatchersMixin from '@/mixins/dispatchers';
import FormWatcher from '@/inheritance/form-watcher';
import { hasNotNumericValues, phoneNum, passwordFormatValidation } from '@/mixins/validations';
import { sha3_512 } from 'js-sha3';

export default {
  name: 'UserDetails',
  mixins: [DispatchersMixin],
  extends: FormWatcher,

  props: {
    id: {
      type: String,
      required: false
    }
  },
  validations: {
    form: {
      username: {
        required,
        email: value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), // Expresión regular para validar email
        minLength: minLength(5),
        maxLength: maxLength(255)
      },
      password: {
        required: requiredIf(function() {
          return this.$route.name === 'users_add';
        }),
        passwordFormatValidation
      },
      given_name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
        hasNotNumericValues
      },
      family_name_1: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(50),
        hasNotNumericValues
      },
      family_name_2: {
        minLength: minLength(2),
        maxLength: maxLength(50),
        hasNotNumericValues
      },
      department: {
        minLength: minLength(2),
        maxLength: maxLength(20)
      },
      telephone: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(20),
        phoneNum
      },
      groupSelected: {
        required
      }
    }
  },
  components: {
    ActionsDetail
  },
  watch: {
    $route: {
      /**
       * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
       */
      handler() {
        if (this.editable) {
          if (
            JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === this.uuid_user
          ) {
            this.warningSelfEdit = true;
            setTimeout(() => {
              this.$bvModal.show(this.modalIdSelfEdit);
            }, 1);
          }
        } else {
          this.fetchData();
          this.saving = false;
          this.savingTitle = 'Guardar cambios';
          this.form.permissionsSelected = null;
        }
      },
      immediate: true
    }
  },
  /**
   * @override
   */
  data() {
    return {
      loading: false,
      user: null,
      groups: [],
      permissions: [],
      saving: false,
      savingTitle: 'Guardar cambios',
      modalIdSelfEdit: 'selfEditWarning',
      warningSelfEdit: null,
      groupSelected: {},
      pendingGroupSelected: {},
      hasGroupSelectedChanged: false,
      uuid_user: undefined,
      userSections: null,
      form: {
        username: null,
        password: null,
        given_name: null,
        telephone: null,
        family_name_1: null,
        family_name_2: null,
        department: null,
        groupSelected: null,
        permissionsSelected: null
      },
      keyUpdate: 0,
      submitted: false,
      formWatcherProperties: ['form']
    };
  },
  methods: {
    /**
     * Obtenemos la información del grupo
     */
    fetchData() {
      this.uuid_user = this.id || this.$route.params.uuid;
      if (this.uuid_user) {
        this.loadUser(this.uuid_user);
      }
    },
    /**
     * @override
     */
    acceptSelfEdit() {
      this.$bvModal.hide(this.modalIdSelfEdit);
      this.warningSelfEdit = false;
    },
    /**
     * Si estamos creando un usuario cerramos la pestaña
     * de lo contrario significa que estamos editando un usuario, por lo tanto volvemos a los detalles de este
     */
    handleCancel() {
      this.deleteStoredComponentData();
      if (this.$route.name === 'users_add') {
        const items = this.$store.getters['yuriMenuStore/items'];
        let indexMenu = 0;
        for (let index = 0; index < items.length; index++) {
          const element = items[index];
          if (element.route.name === 'users_add') {
            indexMenu = index;
          }
        }
        const last = items.find(x => x.route.name === 'users');
        if (last) {
          this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
            this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
              this.$router.replace(last.route);
            });
          });
        } else {
          this.closeActiveTab('dashboard');
        }
      } else {
        this.$router.push({ name: 'users_uuid', params: { uuid: this.user.uuid } });
      }
    },
    /**
     * Mostramos el modal de borrado
     */
    showDeletionModal() {
      this.$bvModal.show('modalRemove');
    },
    /**
     * Ocultamos el modal de borrado
     */
    hideDeletionModal() {
      this.$bvModal.hide('modalRemove');
    },
    /**
     * Borramos el usuario
     */
    deleteUser() {
      this.$usersService
        .deleteByUUIId(this.uuid_user)
        .then(response => {
          this.$toast.success(`${response.result.http_code}`, `${response.result.info || 'Usuario eliminado'}`);
          if (
            JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === this.user.uuid
          ) {
            this.logout();
            this.$router.replace(`/login`);
          } else {
            const items = this.$store.getters['yuriMenuStore/items'];
            const indexActiveMenu = this.$store.getters['yuriMenuStore/activeItem'];
            const last = items.find(x => x.route.name === 'users');
            if (last) {
              this.$store.dispatch('yuriMenuStore/removeItem', indexActiveMenu).then(() => {
                this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                  this.$router.replace(last.route);
                });
              });
            } else {
              this.closeActiveTab('dashboard');
            }
          }
        })
        .catch(err => this.$toast.error(`Error ${err.name}`, `${err.message}`));
    },
    /**
     * Obtenemos la lista de usuarios desde el servicio
     * @param {String} uuid ID del usuario
     */
    loadUser(uuid) {
      console.log('🚀 ~ file: script.js:223 ~ loadUser ~ loadUser:uuid ', uuid);
      this.loading = true;

      const cfg = {
        params: {
          $expand: 'group,permission_set'
        }
      };
      Promise.all([
        this.$usersService.getUsersByUUIId(uuid, cfg),
        this.$groupsService.getGroups('key_name asc'),
        this.$permissionService.getPermissions('key_name asc')
      ])
        .then(res => {
          this.user = res[0].data.user;
          this.form = JSON.parse(JSON.stringify(this.user));
          this.form.groupSelected = {
            uuid: this.form.uuid_group,
            key_name: this.form.group.key_name
          };
          this.groups = res[1].data.groups;
          this.permissions = res[2].data.permission_sets;
          if (this.form.permission_set) {
            this.form.permissionsSelected = {
              uuid: this.form.uuid_permission_set,
              key_name: this.form.permission_set.key_name
            };
          }
          this.keyUpdate++;
          this.loading = false;
          this.$store.dispatch('loaderStore/isVisible', false);
        })
        .catch(() => {
          this.loading = false;

          this.$router.go(-1);
        });
    },
    /**
     * Guardamos la información del usuario
     * @param {Event} e FormEvent
     */
    onSubmit(e) {
      this.$v.$touch();
      this.submitted = true;
      e.preventDefault();

      if (this.$v.$invalid) {
        window.scrollTo(100, 100);
        return;
      }

      this.saving = true;
      this.savingTitle = 'Guardando...';

      if (this.creating) {
        this.createUser();
      } else {
        this.editUser();
      }
    },
    /**
     * Asignamos el uuid del grupo al objecto user
     * Tiene un fix timeout para que asigne el valor
     * @param {Object} e Group info
     */
    dispatchSetGroup(e) {
      this.pendingGroupSelected = e;
      if (this.hasGroupSelectedChanged) {
        this.acceptGroupEditWarningModal();
      } else {
        this.$bvModal.show('groupEditWarning');
      }
    },
    /**
     * Asignamos el uuid del grupo al objecto user
     * Tiene un fix timeout para que asigne el valor
     * @param {Object} e Group info
     */
    dispatchSetPermissions(e) {
      setTimeout(() => {
        this.form._links.permission_set = e._links._self.href;
      }, 100);
      this.keyUpdate++;
    },
    /**
     * Vaciamos un multiselect
     * @param {String} field Nombre del campo
     */
    clearMultiselect(field) {
      switch (field) {
        case 'uuid_permission_set':
          this.form._links.permission_set = null;
          this.form.permissionsSelected = null;
          this.keyUpdate++;
          break;
        default:
          break;
      }
    },
    /**
     * Actualizamos la pestaña actual del menú con el nuevo nombre
     * @param {Object} res Resultado obtenido de la modificación para mostrar en el toast
     */
    updateItemMenu(res) {
      if (JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).user.uuid === this.user.uuid) {
        this.logout();
        this.$toast.success(`Success`, `${res.result.info}`);
        this.$router.replace(`/login`);
      } else {
        this.$store.dispatch('yuriMenuStore/updateItemName', this.fullName).then(() => {
          this.$router.go(-1);
        });
      }
    },
    /**
     * Hacemos logout
     * @override
     */
    logout() {
      this.$authService
        .removeAuthData()
        .then(() => {
          this.$store.dispatch('yuriMenuStore/reset');
          this.$store.dispatch('formStore/deleteAllForms');
        })
        .finally(() => this.$router.replace(`/login`));
    },
    /**
     * Cerramos el modal de aviso de edición de grupo
     */
    closeGroupEditWarningModal() {
      this.$bvModal.hide('groupEditWarning');
      this.pendingGroupSelected = {};
    },
    /**
     * Cerramos el modal de aviso de edición de grupo y aplicamos los cambios
     */
    acceptGroupEditWarningModal() {
      this.$bvModal.hide('groupEditWarning');
      this.clearMultiselect('uuid_permission_set');
      this.hasGroupSelectedChanged = true;
      this.groupSelected = this.pendingGroupSelected;
      this.form.groupSelected = this.pendingGroupSelected;
      this.form._links.group = this.pendingGroupSelected._links._self.href;
      this.pendingGroupSelected = {};
    },

    createUser() {
      this.$usersService
        .create({ ...this.form, password: sha3_512(this.form.password) })
        .then(response => {
          if (response.result && response.result.http_code !== 200) {
            this.saving = false;
            this.savingTitle = 'Guardar cambios';
            const error = response.result.errors[0];
            this.$toast.error(`Error`, `${error.detail}`);
          } else {
            this.deleteStoredComponentData();
            this.closeActiveTab('users');
            this.$toast.success(`${response.result.http_code}`, `${response.result.info || 'Usuario creado'}`);
          }
        })
        .catch(err => {
          console.error(err);
          this.saving = false;
          this.savingTitle = 'Guardar cambios';
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        });
    },

    editUser() {
      this.$usersService
        .update(this.form)
        .then(response => {
          this.fetchData();
          // Actualizar pestaña
          this.updateItemMenu(response);
        })
        .catch(err => {
          this.saving = false;
          this.savingTitle = 'Guardar cambios';
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        })
        .finally(() => {
          this.deleteStoredComponentData();
        });
    }
  },
  computed: {
    getUserInitials: {
      /**
       * Gets User Initials
       * @return {String} User initials
       */
      get() {
        if (this.form.given_name && this.form.family_name_1) {
          const abbr = `${this.form.given_name.substring(0, 1)}${this.form.family_name_1.substring(0, 1)}`;
          return abbr.toUpperCase();
        }
        return '';
      }
    },
    /**
     * Nombre completo del usuario
     * @return {String} Nombre de usuario
     */
    fullName() {
      if (this.user.given_name) {
        return `${this.user.given_name} ${this.user.family_name_1} ${
          this.user.family_name_2 ? this.user.family_name_2 : ''
        }`;
      } else {
        return null;
      }
    },
    /**
     * Indica si estamos editando un usuario o no
     * @return {Boolean} Editable true/false
     */
    editable() {
      if (this.actionObject('USERS', 'edit')) {
        return this.$route.query.edit || this.$route.name === 'users_add' ? true : false;
      }
      return false;
    },
    /**
     * Indica si se está creando un usuario
     * @return {Boolean} Creating true/false
     */
    creating() {
      return this.$route.name === 'users_add';
    }
  },
  /**
   * Carga la información del usuario si se cambia de pestaña
   * @override
   */
  beforeMount() {
    this.saving = false;
    this.savingTitle = 'Guardar cambios';
    this.groups = [];
    this.permissions = [];
    this.form.permissionsSelected = null;
    this.user = null;
    const sections = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).sections;
    this.userSections = {
      groupRead: sections.find(x => x.key_name === 'GROUPS')
        ? sections.find(x => x.key_name === 'GROUPS').permission_object.value.read
        : false,
      groupEdit: sections.find(x => x.key_name === 'GROUPS')
        ? sections.find(x => x.key_name === 'GROUPS').permission_object.value.edit
        : false,
      psRead: sections.find(x => x.key_name === 'PERMISSION_SET')
        ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.read
        : false,
      psEdit: sections.find(x => x.key_name === 'PERMISSION_SET')
        ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.edit
        : false
    };
    // const uuid = newValue.uuid;

    if (this.$route.name !== 'users_add') {
      this.fetchData();
    } else {
      this.user = {};
      this.user.group = {};
      this.user.permission_set = {};
      this.user._links = { permission_set: null };
      this.form._links = { permission_set: null };
      Promise.all([
        this.$groupsService.getGroups('key_name asc'),
        this.$permissionService.getPermissions('key_name asc')
      ]).then(res => {
        this.groups = res[0].data.groups;
        this.permissions = res[1].data.permission_sets;
        this.$store.dispatch('loaderStore/isVisible', false);

        // Si hay datos en el estado los cargamos
        const storedComponentData = this.getStoredComponentData();
        if (storedComponentData && Object.keys(storedComponentData).length) {
          Object.entries(storedComponentData).forEach(([key, value]) => (this[key] = value));
        }
        this.loading = false;
      });
    }
  }
};
